import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 30, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.8, ease: EASE, delay }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, n }) => (
  <div className="font-mono-x flex items-center gap-3 text-xs uppercase tracking-[0.22em] text-teal-300">
    {n && <span className="text-[#2DD4BF]">{n}</span>}
    <span className="h-px w-10 bg-[#2DD4BF]/60" />
    <span>{children}</span>
  </div>
);
